<div class="col-12 p-4">
  <ul class="rounded list-unstyled" [ngStyle]="{'color': menu.colorText, 'border-color': menu.colorText}">
    <li *ngFor="let item of section.items" class="p-2">
      <ng-container *ngIf="item.comment !== 'separator'">
        <div class="row align-items-center">
          <div class="col-8 text-left {{menu.fontHeader}}" (click)="clickName(item)">
            <!-- Label de recomendado -->
            <app-recommend *ngIf="item.home" [menu]="menu"></app-recommend>
            <div translate="no">
              <ng-container *ngIf="!section.upperCaseName">
                {{ item.name | firstuppercase }}
              </ng-container>
              <ng-container *ngIf="section.upperCaseName">
                {{ item.name | uppercase }}
              </ng-container>
            </div>
          </div>
          <div class="col-1">
            <div></div>
          </div>
          <div class="col-3 font-weight-bold text-right {{menu.fontText}}" translate="no">
            {{ item.price | typeNumber: menu.units }}{{item.dollars? '/'+item.dollars+'usd': ''}}
          </div>
        </div>
        <div class="row">
          <!-- Descripcion en espanol -->
          <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'ES'" [innerHTML]="item.description"></p>
          <!-- Descripcion en ingles -->
          <p class="meal-desc {{menu.fontText}}" *ngIf="language === 'EN'" [innerHTML]="item.descriptionEn"></p>
        </div>
      </ng-container>
      <div *ngIf="item.comment === 'separator'">
        <app-separator [menu]="menu" [separator]="item"></app-separator>
      </div>
    </li>
  </ul>
</div>